import lodashClonedeep from "lodash.clonedeep";
import {
  getMaxColorSelectionFromValueConfig,
  getCatalogLoadValueForColor,
  findColorDetailSettingParam,
  findRelatedColorSettingParams,
  findColorSelectionRemoveIndex,
  removeSingleColorSelectionAtIndex,
} from "./printing-colors-preset-utils";

const userMultiParameterModalValues = (settingParameters,isParameterSettings) => {
  const parentParameterCode = settingParameters?.parameter?.code;

  const getColorSettingParams = () =>
    findRelatedColorSettingParams(
      settingParameters?.parameter?.settingParameters ?? [],
      parentParameterCode
    );

    const getSubProduct = (subProducts, subSectionType) => {
        let subProduct = subProducts.find(sub => sub.type === subSectionType);
        if (subProduct) {
          subProduct.parameters = removeDuplicateParameters(subProduct?.parameters);
        }
        return subProduct;
      };
      
      const findParameterValueById = (parameters, parameterId) => {
        if (!parameters?.length || !parameterId) return null;
        const matches = parameters.filter(
          (param) => param.parameterId === parameterId
        );
        if (!matches.length) return null;
        return matches.reduce((best, current) => {
          const bestLen = best?.valueIds?.length ?? 0;
          const currentLen = current?.valueIds?.length ?? 0;
          return currentLen > bestLen ? current : best;
        });
      };

      const removeDuplicateParameters = (parameters) => {
        if (!parameters?.length) return parameters;
        const bestById = new Map();
        parameters.forEach((param) => {
          const existing = bestById.get(param.parameterId);
          const existingLen = existing?.valueIds?.length ?? 0;
          const currentLen = param?.valueIds?.length ?? 0;
          if (!existing || currentLen > existingLen) {
            bestById.set(param.parameterId, param);
          }
        });
        const seen = new Set();
        return parameters.filter((param) => {
          if (seen.has(param.parameterId)) return false;
          seen.add(param.parameterId);
          return bestById.get(param.parameterId) === param;
        });
      };
      const ensureParametersExist = (subProduct, settingParameters, section, subSection) => {
        settingParameters.forEach(settingParam => {
          const existingParam = subProduct?.parameters?.find(param => param.parameterId === settingParam.id);
          if (!existingParam) {
            subProduct.parameters.push({
              parameterId: settingParam.id,
              parameterName: settingParam.name,
              actionId: settingParam.actionId,
              parameterType: settingParam.parameterType,
              parameterCode: settingParam.code,
              values: [],
              valueIds: [],
              sectionId: section.id,
              subSectionId: subSection.id,
              actionIndex: settingParam.actionIndex,
            });
          }
        });
        return subProduct;
      };
      
      const updateValues = (subProduct, value, settingParameters) => {
        const colorParam = settingParameters.find(param => param.code === "printingcolorsDetail" || param.code === "printingcolorsDetailSide2");
        const loadParam = settingParameters.find(param => param.code === "Colorloadpercentage" || param.code === "ColorloadpercentageSide2");
        const layersParam = settingParameters.find(param => param.code === "ColorLayers" || param.code === "ColorLayersSide2");

        if (!colorParam || !loadParam || !layersParam) {
          return subProduct;
        }

        const colorParamValue = findParameterValueById(subProduct?.parameters, colorParam.id);
        const loadParamValue = findParameterValueById(subProduct?.parameters, loadParam.id);
        const layersParamValue = findParameterValueById(subProduct?.parameters, layersParam.id);

        if (!colorParamValue || !loadParamValue || !layersParamValue) {
          return subProduct;
        }

        if (colorParamValue.valueIds?.includes(value.valueId)) {
          return subProduct;
        }

        const defaultColorIds = Array.isArray(colorParam.defaultValueArray)
          ? colorParam.defaultValueArray
          : [];
        const index = defaultColorIds.indexOf(value.valueId);

        const loadDefault =
          loadParam.defaultValue != null ? loadParam.defaultValue : 100;
        const layerDefault =
          layersParam.defaultValue != null ? layersParam.defaultValue : 1;

        let loadValue = loadDefault;
        let layerValue = layerDefault;

        const isSide2 = String(colorParam.code ?? "").includes("Side2");
        const catalogLoad = getCatalogLoadValueForColor(
          settingParameters,
          value.valueId,
          isSide2
        );
        if (catalogLoad != null) {
          loadValue = catalogLoad;
        } else if (index !== -1) {
          const loadArray = Array.isArray(loadParam.defaultValueArray)
            ? loadParam.defaultValueArray
            : [];
          const layersArray = Array.isArray(layersParam.defaultValueArray)
            ? layersParam.defaultValueArray
            : [];
          if (loadArray[index] != null) {
            loadValue = loadArray[index];
          }
          if (layersArray[index] != null) {
            layerValue = layersArray[index];
          }
        }

        colorParamValue.valueIds.push(value.valueId);
        colorParamValue.values.push(value.value);
        loadParamValue.valueIds.push(loadValue);
        loadParamValue.values.push(loadValue);
        layersParamValue.valueIds.push(layerValue);
        layersParamValue.values.push(layerValue);

        return subProduct;
      };
    const getSelectedColorParameterValue = (subProducts) => {
        if (subProducts && !isParameterSettings) {
          const subSection = settingParameters.subSection;
          const subProductType = subSection.type;
          let subProduct = subProducts.find(sub => sub.type === subProductType);
          const colorParameter = findColorDetailSettingParam(
            settingParameters?.parameter?.settingParameters ?? [],
            parentParameterCode
          );
          if (!colorParameter) return null;
          return findParameterValueById(
            subProduct?.parameters,
            colorParameter.id
          );
        }
        return null;
      };

      const addValueToSubProduct = (subProducts, value, settingParameters, section, subSection) => {
        let subProductsCopy = lodashClonedeep(subProducts);
        let subProduct = getSubProduct(subProductsCopy, subSection.type);
      
        if (!subProduct) {
          console.error('SubProduct not found for subSection.type:', subSection.type);
          return subProductsCopy;
        }
      
        subProduct = ensureParametersExist(subProduct, settingParameters.parameter.settingParameters, section, subSection);
      
        if (!subProduct) {
          console.error('SubProduct parameters not ensured.');
          return subProductsCopy;
        }

        // Get the color parameter and its value
        const colorParameter = settingParameters.parameter.settingParameters.find(param => param.code === "printingcolorsDetail" || param.code === "printingcolorsDetailSide2");
        const colorParameterValue = findParameterValueById(
          subProduct?.parameters,
          colorParameter.id
        );

        const parentParameterRow = subProduct?.parameters?.find(
          (paramValue) => paramValue.parameterId === settingParameters?.parameter?.id
        );
        const parentValueConfig = settingParameters?.parameter?.valuesConfigs?.find(
          (conf) => conf.id === parentParameterRow?.valueIds?.[0]
        );
        const maxSelection = parentValueConfig
          ? getMaxColorSelectionFromValueConfig(
              parentValueConfig,
              settingParameters.parameter.settingParameters
            )
          : null;

        if (
          maxSelection != null &&
          colorParameterValue?.valueIds?.length >= maxSelection &&
          !colorParameterValue.valueIds.includes(value.valueId)
        ) {
          return subProductsCopy;
        }

        // Remove any existing duplicates before adding new value
        if (colorParameterValue && colorParameterValue.valueIds) {
            // Create a Set to track unique valueIds
            const uniqueValueIds = new Set();
            const uniqueValues = new Set();
            
            // Filter out duplicates while preserving order
            const uniqueIndices = colorParameterValue.valueIds.reduce((acc, val, idx) => {
                if (!uniqueValueIds.has(val)) {
                    uniqueValueIds.add(val);
                    uniqueValues.add(colorParameterValue.values[idx]);
                    acc.push(idx);
                }
                return acc;
            }, []);

            // Update arrays with unique values
            colorParameterValue.valueIds = uniqueIndices.map(idx => colorParameterValue.valueIds[idx]);
            colorParameterValue.values = uniqueIndices.map(idx => colorParameterValue.values[idx]);

            // Also update related parameters (load and layers)
            const loadParameter = settingParameters.parameter.settingParameters.find(param => param.code === "Colorloadpercentage" || param.code === "ColorloadpercentageSide2");
            const layersParameter = settingParameters.parameter.settingParameters.find(param => param.code === "ColorLayers" || param.code === "ColorLayersSide2");
            
            const loadParameterValue = findParameterValueById(
              subProduct?.parameters,
              loadParameter.id
            );
            const layersParameterValue = findParameterValueById(
              subProduct?.parameters,
              layersParameter.id
            );

            if (loadParameterValue) {
                loadParameterValue.valueIds = uniqueIndices.map(idx => loadParameterValue.valueIds[idx]);
                loadParameterValue.values = uniqueIndices.map(idx => loadParameterValue.values[idx]);
            }

            if (layersParameterValue) {
                layersParameterValue.valueIds = uniqueIndices.map(idx => layersParameterValue.valueIds[idx]);
                layersParameterValue.values = uniqueIndices.map(idx => layersParameterValue.values[idx]);
            }
        }
        subProduct = updateValues(subProduct, value, settingParameters.parameter.settingParameters);
      
        return subProductsCopy;
      };
      const removeValueFromSubProduct = (subProducts, value) => {
        if (!isParameterSettings) {
            const subSection = settingParameters.subSection;
            let subProductsCopy = lodashClonedeep(subProducts);
            const subProductType = subSection.type;
            let subProduct = subProductsCopy.find(sub => sub.type === subProductType);
            if (!subProduct) return subProductsCopy;

            subProduct.parameters = removeDuplicateParameters(subProduct?.parameters);

            const { colorParam, loadParam, layersParam } = getColorSettingParams();
            if (!colorParam) return subProductsCopy;

            const colorParameterValue = findParameterValueById(
              subProduct?.parameters,
              colorParam.id
            );
            const loadParameterValue = loadParam
              ? findParameterValueById(subProduct?.parameters, loadParam.id)
              : null;
            const layersParameterValue = layersParam
              ? findParameterValueById(subProduct?.parameters, layersParam.id)
              : null;

            if (!colorParameterValue?.valueIds?.length) {
              return subProductsCopy;
            }

            const removeIndex = findColorSelectionRemoveIndex(
              colorParameterValue,
              value
            );
            if (removeIndex === -1) {
              return subProductsCopy;
            }

            removeSingleColorSelectionAtIndex(
              colorParameterValue,
              loadParameterValue,
              layersParameterValue,
              removeIndex
            );

            return subProductsCopy;
        }
        return subProducts;
      };
      const setSubProductValue = (subProducts, parameterId, value, textInputVal) => {
        if (!isParameterSettings) {
          const subSection = settingParameters.subSection;
          let subProductsCopy = lodashClonedeep(subProducts);
          const subProductType = subSection.type;
          let subProduct = subProductsCopy.find(sub => sub.type === subProductType);
      
          if (!subProduct) {
            return subProductsCopy;
          }
      
          // Remove duplicate parameters from the subProduct
          subProduct.parameters = removeDuplicateParameters(subProduct?.parameters);

          const colorParameter = findColorDetailSettingParam(
            settingParameters?.parameter?.settingParameters ?? [],
            parentParameterCode
          );
          if (!colorParameter) return subProductsCopy;
          const colorParameterValue = findParameterValueById(
            subProduct?.parameters,
            colorParameter.id
          );
          if (!colorParameterValue?.valueIds?.length) {
            return subProductsCopy;
          }

          const valueIndex = colorParameterValue.valueIds.findIndex(val => val === value.valueId);
          if (valueIndex === -1) {
            return subProductsCopy;
          }

          const parameterValue = findParameterValueById(
            subProduct?.parameters,
            parameterId
          );
          if (!parameterValue) {
            return subProductsCopy;
          }

          const parameterValueIndex = subProduct.parameters.indexOf(parameterValue);
          if (parameterValueIndex === -1) {
            return subProductsCopy;
          }

          const nextValues = [...(parameterValue.values ?? [])];
          const nextValueIds = [...(parameterValue.valueIds ?? [])];
          while (nextValues.length <= valueIndex) {
            nextValues.push(textInputVal);
          }
          while (nextValueIds.length <= valueIndex) {
            nextValueIds.push(textInputVal);
          }
          nextValues[valueIndex] = textInputVal;
          nextValueIds[valueIndex] = textInputVal;

          subProduct.parameters[parameterValueIndex] = {
            ...parameterValue,
            values: nextValues,
            valueIds: nextValueIds,
          };
          return subProductsCopy;
        }
        return subProducts; // Return the original subProducts if isParameterSettings is true
      };
    const setSubProductValueForParameterSettings = (selectedParameterValues, parameterId, value, textInputVal) => {
        if (isParameterSettings) {
          // Clone the selectedParameterValues to avoid mutating the original state
          let parametersCopy = lodashClonedeep(selectedParameterValues);
          
          // Step 1: Find the parameter for colors to get the correct index
          const colorParameter = parametersCopy?.find(param => param.parameterId === "8eff3238-a321-48f3-85eb-c14afaccbff3" || param.parameterId === "ae8d81d1-a0de-4967-b821-dae6937e7551");
          if (!colorParameter) return parametersCopy; // Exit if color parameter not found
          
          // Step 2: Find the index of the valueId within the colors parameter
          const valueIndex = colorParameter.valueIds.indexOf(value.valueId);
          if (valueIndex === -1) return parametersCopy; // Exit if valueId not found
          
          // Step 3: Find the parameter to be updated using the parameterId
          const parameterToUpdate = parametersCopy.find(param => param.parameterId === parameterId);
          if (!parameterToUpdate || !parameterToUpdate.valueIds) return parametersCopy; // Exit if parameter not found
          
          // Step 4: Update the value at the correct index
          parameterToUpdate.valueIds[valueIndex] = textInputVal;
          
          return parametersCopy; // Return the updated parameters
        }
        return selectedParameterValues; // If isParameterSettings is false, return the original values
      };

      const setSubProductValueForParameterSettingsDefaultValueArray = (parameters, parameterId, value, textInputVal) => {

        // Step 1: Find the parameter for colors to get the correct index
        const colorsParameter = parameters.find(param => param.code === "printingcolorsDetail" || param.code === "printingcolorsDetailSide2");
        if (!colorsParameter) return parameters; // Exit if color parameter not found
      
        // If the edited parameter is the aggregate average load, mirror it to the load-percentage array
        const isAvgLoadParam = parameters.some(p => p.id === parameterId && (p.code === "ColorsLoadAverage" || p.code === "ColorsLoadAverageSide2"));
        if (isAvgLoadParam) {
          const loadParam = parameters.find(p => (p.code === "Colorloadpercentage" || p.code === "ColorloadpercentageSide2"));
          if (!loadParam) return parameters;
          const effectiveLen = Math.max(
            colorsParameter.defaultValueArray?.length ?? 0,
            loadParam.defaultValueArray?.length ?? 0,
            1
          );
          return parameters.map(param => {
            if (param.id === loadParam.id) {
              return {
                ...param,
                defaultValue: textInputVal,
                defaultValueArray: Array(effectiveLen).fill(textInputVal),
              };
            }
            if (param.id === parameterId) {
              return { ...param, defaultValue: textInputVal };
            }
            return param;
          });
        }
      
        // Step 2: Find the index of the valueId within the colors parameter
        const colorDefaultIds = Array.isArray(colorsParameter.defaultValueArray)
          ? colorsParameter.defaultValueArray
          : [];
        const valueIndex = colorDefaultIds.findIndex(val => val === value.valueId);
        if (valueIndex === -1) return parameters; // Exit if valueId not found
      
        // Step 3: Find the parameter to be updated using the parameterId
        const parameterToUpdate = parameters.find(param => param.id === parameterId);
        if (!parameterToUpdate || !Array.isArray(parameterToUpdate.defaultValueArray)) return parameters; // Exit if parameter not found
      
        // Step 4: Update the value at the correct index in defaultValueArray
        const updatedParameters = parameters.map(param => {
          if (param.id === parameterId) {
            const newDefaultValueArray = [...param.defaultValueArray];
            newDefaultValueArray[valueIndex] = textInputVal;
            return {
              ...param,
              defaultValueArray: newDefaultValueArray
            };
          }
          return param;
        });
      
        return updatedParameters; // Return the updated parameters array
      };
    return {
        addValueToSubProduct,
        removeValueFromSubProduct,
        setSubProductValue,
        getSelectedColorParameterValue,
        setSubProductValueForParameterSettings,
        setSubProductValueForParameterSettingsDefaultValueArray,
        removeDuplicateParameters
    };
};

export { userMultiParameterModalValues };
